var map = {
	"./404/404": 520,
	"./404/404.html": 252,
	"./404/404.ts": 520,
	"./accessibility/accessibility-dck-de.html": 178,
	"./accessibility/accessibility-dck-en.html": 178,
	"./accessibility/accessibility-de.html": 179,
	"./accessibility/accessibility-en.html": 179,
	"./camping/camping-dck-de.html": 521,
	"./camping/camping-dck-en.html": 522,
	"./camping/camping-de.html": 523,
	"./camping/camping-en.html": 526,
	"./editor/_common": 57,
	"./editor/_common.ts": 57,
	"./editor/widget-cite/widget-cite": 255,
	"./editor/widget-cite/widget-cite-edit.html": 257,
	"./editor/widget-cite/widget-cite.html": 256,
	"./editor/widget-cite/widget-cite.ts": 255,
	"./editor/widget-container/layout-2-columns.html": 258,
	"./editor/widget-container/layout-3-columns.html": 259,
	"./editor/widget-container/layout-hero.html": 260,
	"./editor/widget-container/layout-left-column.html": 261,
	"./editor/widget-container/layout-vertical.html": 262,
	"./editor/widget-container/placeholder.html": 263,
	"./editor/widget-container/widget-container": 264,
	"./editor/widget-container/widget-container-edit.html": 268,
	"./editor/widget-container/widget-container.html": 267,
	"./editor/widget-container/widget-container.ts": 264,
	"./editor/widget-container/widget-selection-modalbody.html": 266,
	"./editor/widget-countdown/widget-countdown": 269,
	"./editor/widget-countdown/widget-countdown-edit.html": 271,
	"./editor/widget-countdown/widget-countdown.html": 270,
	"./editor/widget-countdown/widget-countdown.ts": 269,
	"./editor/widget-empty/widget-empty": 272,
	"./editor/widget-empty/widget-empty.html": 273,
	"./editor/widget-empty/widget-empty.ts": 272,
	"./editor/widget-gallery/widget-gallery": 274,
	"./editor/widget-gallery/widget-gallery-edit.html": 276,
	"./editor/widget-gallery/widget-gallery.html": 275,
	"./editor/widget-gallery/widget-gallery.ts": 274,
	"./editor/widget-image/widget-image": 277,
	"./editor/widget-image/widget-image-edit.html": 279,
	"./editor/widget-image/widget-image.html": 278,
	"./editor/widget-image/widget-image.ts": 277,
	"./editor/widget-page/widget-page": 280,
	"./editor/widget-page/widget-page-edit.html": 282,
	"./editor/widget-page/widget-page.html": 281,
	"./editor/widget-page/widget-page.ts": 280,
	"./editor/widget-richtext/widget-richtext": 283,
	"./editor/widget-richtext/widget-richtext-edit.html": 290,
	"./editor/widget-richtext/widget-richtext.html": 289,
	"./editor/widget-richtext/widget-richtext.ts": 283,
	"./editor/widget-utils": 548,
	"./editor/widget-utils.ts": 548,
	"./editor/widget-video/widget-video": 291,
	"./editor/widget-video/widget-video-edit.html": 293,
	"./editor/widget-video/widget-video.html": 292,
	"./editor/widget-video/widget-video.ts": 291,
	"./home/home": 549,
	"./home/home-dck-de.html": 550,
	"./home/home-de.html": 551,
	"./home/home.html": 294,
	"./home/home.ts": 549,
	"./imprint/imprint-dck-de.html": 552,
	"./imprint/imprint-de.html": 192,
	"./imprint/imprint-en.html": 192,
	"./leisure/leisure-dck-de.html": 553,
	"./leisure/leisure-de.html": 193,
	"./leisure/leisure-en.html": 193,
	"./mobile-homes/mobile-homes-dck-de.html": 554,
	"./mobile-homes/mobile-homes-dck-en.html": 555,
	"./mobile-homes/mobile-homes-de.html": 194,
	"./mobile-homes/mobile-homes-en.html": 194,
	"./permanent-stay/permanent-stay-de.html": 195,
	"./permanent-stay/permanent-stay-en.html": 195,
	"./prices/prices-dck-de.html": 556,
	"./prices/prices-dck-en.html": 557,
	"./prices/prices-de.html": 196,
	"./prices/prices-en.html": 196,
	"./privacy/privacy-de.html": 197,
	"./privacy/privacy-en.html": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1023;